import { typography as designSystemTypography } from '@openx/design-system/theme/tokens/typography';

export const WEIGHT_LIGHT = designSystemTypography.fontWeightLight;
export const WEIGHT_NORMAL = designSystemTypography.fontWeightRegular;
export const WEIGHT_MEDIUM = designSystemTypography.fontWeightMedium;
export const WEIGHT_SEMIBOLD = designSystemTypography.fontWeightBold;
// No Design System token for 800 — kept until the remaining usages are migrated (UIG-1129)
export const WEIGHT_EXTRABOLD = 800;

// Design System typography (Figtree). subtitle1, subtitle2 and h4–h6 are not styled by the DS
// and intentionally fall back to MUI defaults.
export const typography = designSystemTypography;
